import { createAsyncThunk } from '@reduxjs/toolkit'
import { orderServices } from '@services'
import { INVENTORY_STATUS } from '@common'

export const fetchOrderByNumber = createAsyncThunk('order/fetchOrderByNumber', async (input, thunk) => {
    try {
        const res = await orderServices.fetchOrderByNumber(input)

        if (!!res.error || !res.order) {
            return thunk.rejectWithValue('Invalid order id')
        }

        return res.order
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const submitOrder = createAsyncThunk('order/submitOrder', async (input, thunk) => {
    try {
        const res = await orderServices.submitOrder(input)

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        const order = res.order || {}
        return { ...order, promoResult: res.promoResult || null }
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const submitMemberOrder = createAsyncThunk('order/submitMemberOrder', async (input, thunk) => {
    try {
        const res = await orderServices.submitMemberOrder(input)

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        const order = res.order || {}
        return { ...order, promoResult: res.promoResult || null }
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const cancelProduct = createAsyncThunk('order/cancelProduct', async (productId, thunk) => {
    try {
        const response = await orderServices.cancelProduct(productId)

        return { result: response, productId }
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const checkInventoryStatus = createAsyncThunk('order/checkInventoryStatus', async (ids, thunk) => {
    try {
        const res = await orderServices.checkInventoryStatus(ids)

        if (!!res.error || !res.inventories) {
            return thunk.rejectWithValue('Invalid inventory ids')
        }

        return { inventoryStatus: res.inventories, isAllActive: res.inventories.every(i => i.status === INVENTORY_STATUS.ACTIVE) }
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchOrderById = createAsyncThunk('order/fetchOrderById', async (orderId, thunk) => {
    try {
        const res = await orderServices.fetchOrders({ orderId })

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        return res.orders[0]
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchAvailablePromos = createAsyncThunk('order/fetchAvailablePromos', async (_, thunk) => {
    try {
        const res = await orderServices.fetchAvailablePromos()

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        return res || []
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})
